var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.0133C17.2206 12.0133 18.0439 12.5406 18.5134 12.9811L20.3478 11.19C19.2211 10.1428 17.755 9.5 16 9.5C13.4578 9.5 11.2622 10.9589 10.1934 13.0822L12.295 14.7144C12.8222 13.1472 14.2811 12.0133 16 12.0133Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.24 16.1443C22.24 15.6099 22.1967 15.2199 22.1028 14.8154H16V17.2277H19.5822C19.51 17.8271 19.12 18.7299 18.2533 19.3365L20.3044 20.9254C21.5322 19.7915 22.24 18.1232 22.24 16.1443Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3022 17.2856C12.165 16.8812 12.0856 16.4478 12.0856 16.0001C12.0856 15.5523 12.165 15.1189 12.295 14.7145L10.1933 13.0823C9.75278 13.9634 9.5 14.9528 9.5 16.0001C9.5 17.0473 9.75278 18.0367 10.1933 18.9178L12.3022 17.2856Z",
    fill: "#FBBC05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 22.5001C17.7549 22.5001 19.2282 21.9223 20.3043 20.9256L18.2532 19.3368C17.7043 19.7195 16.9677 19.9868 15.9999 19.9868C14.281 19.9868 12.8221 18.8529 12.3021 17.2856L10.2004 18.9179C11.2693 21.0412 13.4577 22.5001 15.9999 22.5001Z",
    fill: "#34A853"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.acfbd096.svg";
export { ForwardRef as ReactComponent };